import { useSelector } from 'react-redux';

import { DefaultAvatar } from 'atoms/default-avatar';
import { prettifyPhoneNumber } from 'util';

export default function Header() {
  const { appointment } = useSelector((state) => state.checkout);
  const animal = appointment?.animal;
  const petAvatar = animal?.avatarUrls?.mobile?.small;
  const petDetails = [];
  if (animal.breed?.value) petDetails.push(animal.breed?.value);
  if (animal.size?.value) petDetails.push(animal.size?.value);
  if (animal.vaccinations?.length > 0) petDetails.push('Vaccinated');

  return (
    <div className="flex-row mb-12 p-24 border-light-purple radius-24">
      <DefaultAvatar avatar={petAvatar} size="small" animal={animal} />
      <div className="flex-column ml-8">
        <p className="f13 bold">{animal?.name}</p>
        <p className="f11 c-primary-purple">{petDetails.join(' • ')}</p>
        <p className="f11 c-primary-purple">
          <span>
            {appointment?.user?.firstName} {appointment?.user?.lastName},{' '}
          </span>
          {appointment?.user?.phone
            ? prettifyPhoneNumber({
                number: appointment?.user?.phone?.number,
                countryCode: appointment?.user?.phone?.country?.code?.value,
              })
            : ''}
        </p>
      </div>
    </div>
  );
}
